module.exports = __webpack_public_path__ + "static/media/weather_2.05b93042.svg";